import { registerComponent } from '../app'
import { OPEN_MENU, CLOSE_MENU } from '../events'

const ToggleMenuButton = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	const state = {
		open: false
	}

	scope.on(OPEN_MENU, () => {
		state.open = true
		el.classList.add(props.openClass)
	})

	scope.on(CLOSE_MENU, () => {
		state.open = false
		el.classList.remove(props.openClass)
	})

	el.addEventListener('click', () => {
		state.open ? scope.emit(CLOSE_MENU) : scope.emit(OPEN_MENU)
	})
}

registerComponent('toggle-menu-button', ToggleMenuButton)
